import { render, staticRenderFns } from "./forgot-password-dialog.vue?vue&type=template&id=82d03292&scoped=true"
import script from "./forgot-password-dialog.vue?vue&type=script&lang=js"
export * from "./forgot-password-dialog.vue?vue&type=script&lang=js"
import style0 from "./forgot-password-dialog.vue?vue&type=style&index=0&id=82d03292&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82d03292",
  null
  
)

export default component.exports